import React from "react";
import { usePokemonMemory } from "../context/PokemonMemoryContext";

const DifficultyMenu = () => {
  const { gameState, updateGameState } = usePokemonMemory();
  if (gameState.difficulty !== "") {
    return <></>;
  }

  const difficulties = ["Easy", "Medium", "Hard"];

  return (
    <div className="grid h-[30vh] w-[30vh] mx-auto gap-4 grid-cols-1">
      {difficulties.map((difficulty) => (
        <button
          key={difficulty}
          className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-4 px-8 rounded-lg transition-colors text-xl"
          onClick={() => {
            updateGameState({ ...gameState, difficulty: difficulty });
          }}
        >
          {difficulty}
        </button>
      ))}
    </div>
  );
};

export default DifficultyMenu;
